const $ = jQuery;

let siteSearch = $('#site-search');

$('.search-link').on('click', function (e) {
    e.preventDefault();

    if($(this).hasClass('is-open')) {
        closeSearch();
    } else {
        openSearch();
    }
});

function openSearch() {
    siteSearch.slideDown();
    $('.search-link').addClass('is-open');
}

function closeSearch() {
    siteSearch.slideUp();
    $('.search-link').removeClass('is-open');
}

$('.menu-toggle').on('click', function () {

    if($(this).hasClass('is-open')) {
        closeMenu();
    } else {
        openMenu();
    }

});

function openMenu() {
    $('.menu-toggle').addClass('is-open');
    $('.main-menu').slideDown();
    $('#siteHeader').addClass('is-open');
}

function closeMenu() {
    $('.menu-toggle').removeClass('is-open');
    $('.main-menu').slideUp();
    $('#siteHeader').removeClass('is-open');
}

if($(window).width() > 991) {
    $('.menu-item-has-children').hover(function () {
        let subMenu = $(this).find('ul');
        subMenu.addClass('showing');
        setTimeout(() => {
            subMenu.removeClass('hiding');
        }, 10);
    }, function () {
        let subMenu = $(this).find('ul');
        subMenu.addClass('hiding');
        setTimeout(() => {
            subMenu.removeClass('showing');
        }, 310);
    });
}

if($(window).width() <= 991) {
    $('.menu-item-has-children').each(function () {
        $(this).append('<span class="menu-toggle-handle">▼</span>');
    });

    $('.menu-toggle-handle').on('click', function () {
        let subMenu = $(this).parent().find('ul');

        if(!$(this).hasClass('is-open')) {
            subMenu.slideDown();
            // subMenu.addClass('showing');
            // setTimeout(() => {
            //     subMenu.removeClass('hiding');
            // }, 10);
            $(this).addClass('is-open');
        } else {
            subMenu.slideUp();
            // subMenu.addClass('hiding');
            // setTimeout(() => {
            //     subMenu.removeClass('showing');
            // }, 310);
            $(this).removeClass('is-open');
        }
    });
}
